/* eslint-disable */
import React, { useState, useEffect } from "react";
import Icon from "../components/Icon";
import Wrapper from "../components/Wrapper";
import Option from "../components/Option";
import Button from "../components/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  addScreenAction,
  updateScreenAction,
  backScreenAction,
} from "../actions";
import {
  INTENDED_APP,
  QUESTION6,
  HOME_SIZE,
  GARDEN_TAPS,
  SHOW_MORE,
  QUESTION4,
  IRRIGATION,
  IS_MAINS,
} from "../constants";

function Question5({ screens, addScreen, backScreen, updateScreen }) {
  const [small, setSmall] = useState(false);
  const [medium, setMedium] = useState(false);
  const [large, setLarge] = useState(false);
  const homeSizeOpt = [
    {
      description: "1-3 outlets being used at the same time.",
      name: "Small single storey or townhouse.",
      iconName: "small-single-story",
      optionClassName: `${small ? "c-quiz_options--option-selected" : ""}`,
      action: () => {
        setSmall(true);
        setMedium(false);
        setLarge(false);
      },
    },
    {
      description: "4-5 outlets being used at the same time.",
      name: "Medium single or double storey.",
      iconName: "medium-single-story",
      optionClassName: `${medium ? "c-quiz_options--option-selected" : ""}`,
      action: () => {
        setSmall(false);
        setMedium(true);
        setLarge(false);
      },
    },
    {
      description: "6 or more outlets being used at the same time.",
      name: "Large house or double storey.",
      iconName: "large-house-or-double",
      optionClassName: `${large ? "c-quiz_options--option-selected" : ""}`,
      action: () => {
        setSmall(false);
        setMedium(false);
        setLarge(true);
      },
    },
  ];
  const [counter, setCounter] = useState(0);
  const countRef = React.createRef();

  const isGarden = screens.answers.INTENDED_APP === "garden";
  const buttonDisabled = () => {
    let isBtnDisabled;
    if (isGarden) {
      isBtnDisabled = counter === 0;
      return isBtnDisabled;
    } else {
      isBtnDisabled === !small && !medium && !large;
      return isBtnDisabled;
    }
  };
  const getQuestion = () => {
    if (isGarden) {
      return "5. How many garden taps will be running at the same time?";
    } else {
      return "5. What best describes the size of the home?";
    }
    return "";
  };

  const getDesc = () => {
    if (isGarden) {
      return "Domestic garden taps only.";
    } else {
      return "Outlets are defined as toilets, garden taps and/or a washing machine.";
    }
  };
  const getAnswer = () => {
    if (!isGarden) {
      if (small) {
        return "small";
      } else if (medium) {
        return "medium";
      } else {
        return "large";
      }
    } else {
      return counter;
    }
    return "";
  };

  const getAnswerKey = () => {
    if (isGarden) {
      return GARDEN_TAPS;
    } else {
      return HOME_SIZE;
    }
  };

  useEffect(() => {
    if (countRef.current) countRef.current.focus();
  });

  useEffect(() => {
    if (screens.answers.GARDEN_TAPS) {
      setCounter(screens.answers.GARDEN_TAPS);
    }
    if (screens.answers.HOME_SIZE) {
      if (screens.answers.HOME_SIZE === "small") {
        setSmall(true);
      }
      if (screens.answers.HOME_SIZE === "medium") {
        setMedium(true);
      }
      if (screens.answers.HOME_SIZE === "large") {
        setLarge(true);
      }
    }
    // }
  }, []);
  return (
    <div>
      <Wrapper stepNo={"5"} question={getQuestion()} description={getDesc()}>
        {!isGarden && (
          <div
            className="uk-child-width-expand@s uk-grid-match uk-text-center c-quiz_options"
            uk-grid="margin: uk-margin-small uk-margin@s"
          >
            {homeSizeOpt.map((option) => {
              return (
                <Option
                  key={`opt_${option.name}`}
                  name={option.name}
                  iconName={option.iconName}
                  description={option.description}
                  optionClassName={option.optionClassName}
                  onClick={option.action}
                />
              );
            })}
          </div>
        )}
        {isGarden && (
          <div
            className="uk-child-width-expand@s uk-card uk-card-default uk-card-body c-garden"
            uk-grid="margin: uk-margin-small uk-margin@s"
          >
            <div className="icon-lg c-garden__icon">
              <Icon iconName="bore-water" className="icon-md" />
            </div>
            <div className="c-garden__taps">
              <h3 className="c-garden__taps-head">Garden taps at once</h3>
              <div className="uk-margin">
                <select
                  className="uk-select"
                  aria-label="Custom controls"
                  name="taps"
                  value={counter}
                  onChange={(e) => {
                    setCounter(Number(e.target.value));
                  }}
                  ref={countRef}
                >
                  <option value="1">1 tap</option>
                  <option value="2">2 taps</option>
                  <option value="3">3 taps</option>
                  <option value="4">4 taps</option>
                  <option value="5">5+ taps</option>
                </select>
              </div>
            </div>
          </div>
        )}
        <Button
          text={"Back"}
          secondary
          onClick={() => {
            if (screens.answers.IRRIGATION) {
              backScreen({
                back_screen: QUESTION4,
              });
            } else if (screens.answers.IS_MAINS) {
              backScreen({
                back_screen: QUESTION4,
              });
            } else {
              backScreen({
                back_screen: HOME_SIZE,
              });
            }
          }}
        />

        <Button
          text={"continue"}
          disabled={buttonDisabled()}
          onClick={() => {
            const answer = getAnswer();
            const key = getAnswerKey();
            if (isGarden && answer >= 5) {
              updateScreen({
                curr_screen: key,
                next_screen: SHOW_MORE,
                answer: answer,
              });
            } else {
              updateScreen({
                curr_screen: key,
                next_screen: QUESTION6,
                answer: answer,
              });
            }
          }}
        />
      </Wrapper>
    </div>
  );
}

const mapStateToProps = (state) => ({
  screens: state.questions,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateScreen: updateScreenAction,
      addScreen: addScreenAction,
      backScreen: backScreenAction,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(Question5);
